var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("p", [
      _vm._v(" "),
      _c("br"),
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isExpanded,
              expression: "!isExpanded",
            },
          ],
          attrs: {
            href: "#",
            id: "travel-agent-link",
            title: "Click to enter travel agent IATA",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.showForm.apply(null, arguments)
            },
          },
        },
        [_vm._v("Click here if you are a travel agent.")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExpanded,
            expression: "isExpanded",
          },
        ],
        staticClass: "pepvalidate-v3 ajax-ignore full-width",
        attrs: { id: "travel-agent-form" },
      },
      [
        _c("p", { staticClass: "full-width" }, [
          _vm._v("Enter your IATA below."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "full-width" }, [
          _c("label", [
            _c("span", { staticClass: "text" }, [_vm._v("IATA")]),
            _vm._v(" "),
            _c("input", {
              attrs: { name: "iata", type: "text" },
              domProps: { value: _vm.bookingLinkData.iata },
              on: {
                input: function ($event) {
                  _vm.bookingLinkData.iata = $event
                },
              },
            }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }